import * as actionTypes from '../actions/Actions';


export const initialState = {
  data: {
    isOpen: false,
    feature: '',
    contractId: '',
    title: 'Are you confirm ?',
    message: ' This is message',
    active: false
  },
}

const confirmReducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.SHOW_CONFIRM_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          feature: action.feature,
          title: action.title,
          message: action.message,
        }
      }

    case actionTypes.SHOW_CONFIRM_UPGRADE_CARD_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          feature: action.feature,
          contractId: action.contractId,
          title: action.title,
          message: action.message,
        }

      }
    case actionTypes.CLOSE_CONFIRM_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: false,
        },
      }


    default:
      return state;
    case actionTypes.SHOW_CONFIRM_ACTIVE_CARD_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          isOpen: true,
          feature: action.feature,
          contractId: action.contractId,
          title: action.title,
          message: action.message,
        }
      }
    case actionTypes.SET_ACTIVE_CARD:
      return {
        ...state,
        data: {
          ...state.data,
          active: !state.data.active
        }
      }
  }
}

export default confirmReducer;